import React from 'react';
import { GoogleLogin } from 'react-google-login';
import axios from 'axios';

const Login = ({ onLoginSuccess }) => {
  const clientId = '13853097929-eo23ra6sblur4qb20io57qgp2bfdi94m.apps.googleusercontent.com';

  const handleLoginSuccess = async (response) => {
    const token = response.tokenId;

    try {
      // Verify the user's email domain on the backend
      const res = await axios.post('/api/auth/google', { token });

      if (res.data.allowed) {
        onLoginSuccess(res.data.user); // Pass user data to parent component
      } else {
        alert('Access restricted to mxssolutions.com domain users.');
      }
    } catch (error) {
      console.error('Error verifying Google login:', error);
      alert('Authentication failed.');
    }
  };

  const handleLoginFailure = (error) => {
    console.error('Google Login failed:', error);
    alert('Login failed. Please try again.');
  };

  return (
    <div style={{height: "100vh", width: "100vw", justifyContent: "center"}}>
      <div style={{width: "500px"}}>
        <GoogleLogin
          clientId={clientId}
          buttonText="Login with Google"
          onSuccess={handleLoginSuccess}
          onFailure={handleLoginFailure}
          cookiePolicy={'single_host_origin'}
          uxMode="redirect"  // Use redirect instead of popup
          redirectUri="http://localhost:3001" // Make sure this matches your Google Cloud Console settings
        />
      </div>
    </div>
  );
};

export default Login;
